import { render, staticRenderFns } from "./Comedy.vue?vue&type=template&id=ee350e58&scoped=true&"
import script from "./Comedy.vue?vue&type=script&lang=js&"
export * from "./Comedy.vue?vue&type=script&lang=js&"
import style0 from "./Comedy.vue?vue&type=style&index=0&id=ee350e58&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee350e58",
  null
  
)

export default component.exports